import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { WidgetDateV0Utils } from './widget-date-v0.utils';
import { IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-widget-date-v0-preview',
  template: `
    <ng-container *ngIf='loading; then LOADING; else PREVIEW'></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>

      <ng-container *ngIf='noData ; then NODATA; else DATA'></ng-container>

      <ng-template #NODATA>
        <pt-widget-nodata [noDataLabel]="noDataLabel"></pt-widget-nodata>
      </ng-template>

      <ng-template #DATA>
        <div class='input-group input-group-sm pt-widget-date-v0-preview'>
          <input type='text'
                 class='form-control form-control-sm'
                 value='{{textDate}}'
                 disabled>
          <span class='input-group-text'>
            <pt-icon [key]='IconCalendar' [size]='18'></pt-icon>
          </span>
        </div>

      </ng-template>
    </ng-template>
  `,
  styles: [
    `
      .pt-widget-date-v0-preview {
        width: 235px;
      }

      .pt-widget-date-v0-preview input {
        background: white;
      }
    `
  ]
})
export class WidgetDateV0PreviewComponent implements OnChanges {
  @Input() noDataLabel?: string;
  @Input() previewData: number;
  @Input() loading: boolean;
  @Input() currentLanguage: string;
  public IconCalendar = IoniconsOutline.calendarCheck;

  textDate: string;
  noData: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.previewData) {
      this.noData = !Number.isSafeInteger(this.previewData);
      this.textDate = WidgetDateV0Utils.timestampToString(this.previewData, this.currentLanguage);
    }
  }
}
